// components/MyProfileRedirect.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function MyProfileRedirect() {
    const { user, loading } = useAuth();

    if (loading) return <p>Loading…</p>;
    if (!user)   return <Navigate to="/login" />;

    return <Navigate to={`/profile/${user.id}`} replace />;
}